<template >
  <b-datepicker
    v-bind="$attrs"
    :icon="icon"
    :events="events"
    :unselectable-days-of-week=" disableWeekendDays ? [6,0] : null "
    :date-formatter="dateFormatter"
    :date-parser="dateParser"
    :date-creator="dateCreator"
    :focused-date="forcusedDate()"
    indicators="bars"
    @input="onInput"
    ref="datepicker"
    :min-date="minDateTz"
    :max-date="maxDateTz"
    :unselectable-dates="disableDates"
  />
</template>

<script>
// editor note:
// because buefy got issue with date parser and date formatter
// which hard to modify date internal buefy component.
// we must wrap datepicker into other component to proxy data
import { DateTime } from 'luxon'
import store from '@/store'

export default {
  name: 'SourceSelectDate',
  props: {
    value: { type: String, default: () => null },
    icon: { type: String, default: () => 'calendar-alt' },
    minDate: { type: String, default: () => null },
    maxDate: { type: String, default: () => null },
    disableWeekendDays: { type: Boolean, default: () => false },
    disableEventDate: { type: Boolean, default: () => false },
    events: { type: Array, default: () => null },
  },
  computed: {
    Timezone() {
      return store.state.user.me.Timezone
    },
    // convert min date
    minDateTz() {
      if (!this.minDate) return this.minDate
      return (
        DateTime
          // remember setzone option so DateTime class will not auto convert timezone
          .fromISO(this.minDate, { setZone: true })
          .setZone(null, { keepLocalTime: true })
          .toJSDate()
      )
    },
    // convert max date
    maxDateTz() {
      if (!this.maxDate) return this.maxDate
      return DateTime.fromISO(this.maxDate, { setZone: true })
        .setZone(null, { keepLocalTime: true })
        .toJSDate()
    },
    // disable dates
    disableDates() {
      // find event date
      const dates = []
      if (this.disableEventDate === true) {
        this.events.forEach(n => dates.push(n.date))
      }
      return dates
    },
  },

  mounted() {
    const self = this
    // listen changes from model outside
    // value will be iso utc date. so we first need convert it to account' timezone
    // then convert timzone-only from account's timezone to computed's timezone
    self.$watch(
      'value',
      value => {
        const model = self.$refs.datepicker
        // skip and clear if not config
        if (value == null) {
          self.$refs.datepicker.dateSelected = null
          return void 0
        }

        const valueInLocalDate = DateTime
          // in utc date timzone (no auto convert)
          .fromISO(value, { setZone: true })
          // convert date value to account' timezone
          .setZone(self.Timezone)
          // conver timezone-only to computer's timezone
          .setZone(null, { keepLocalTime: true })
          .toJSDate()

        // avoid convert to many time
        const modelDate = model.dateSelected
        if (modelDate != null && modelDate === valueInLocalDate) return void 0

        // update selected date
        model.dateSelected = valueInLocalDate
      },
      { immediate: true },
    )
  },
  methods: {
    // date picker convert date
    // - date formatter
    // Function to format date to a string for display in the input
    dateFormatter(date) {
      return DateTime.fromJSDate(date).toLocaleString(DateTime.DATE_MED)
    },

    // Function to parse string to a date for set a date from the input to the component
    dateParser(date) {
      return DateTime.fromJSDate(Date.parse(date))
        .setZone(this.Timezone)
        .setZone(null, { keepLocalTime: true })
        .toJSDate()
    },
    // Function used internally to create a new Date instance
    dateCreator() {
      return DateTime.local()
        .setZone(this.Timezone)
        .setZone(null, { keepLocalTime: true })
        .toJSDate()
    },
    // Date that should be initially focused upon
    // attention: because buefy's datetime picker force use native Date class
    // when convet from string or DateTime module to Native Date class, if source
    // contains timezone it will be converted to current computer's timezone
    // so we need extra step is convert timezone back to computer's timezone
    // but keep date time, only replace timezone.
    // like this we will have correct date time of account's timezone with fake (computer timezone)
    // running underground
    forcusedDate() {
      return DateTime.local()
        .setZone(this.Timezone)
        .setZone(null, { keepLocalTime: true })
        .toJSDate()
    },

    // when user select date
    onInput(date) {
      // because date from datepicker converted with fake timzone
      // first we need convert fake timezone (computer's timezone) to account's timezone
      // put keep same date time value
      // second, we need convert value to utc because whole data use common timzone is UTC
      if (date == null) this.$emit('input', null)
      else
        this.$emit(
          'input',
          DateTime.fromJSDate(date)
            .setZone(this.Timezone, { keepLocalTime: true })
            .toUTC()
            .toISO(),
        )
    },
  },
}
</script>

